import { Injectable } from '@angular/core';
import { RedirectCommand, Resolve } from '@angular/router';
import { Distributor } from '@wsphere/distributors/domain';

@Injectable()
export class DistributorResolver implements Resolve<Distributor.Model | null | RedirectCommand> {
  distributor!: Distributor.Model | null;

  async resolve(): Promise<Distributor.Model | null> {
    return this.distributor || null;
  }
}
